import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { Tax } from 'models/TaxModel';


const TaxList: React.FC = () => {
  const width = { name: 20, percent: 20, comment: 54 };
  const [formId, formName] = [Code.Form.Id.TAX, Code.Form.Name.TAX];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [taxData, setTaxData] = useState<Tax[]>([]); 
  const [selectedTax, setselectedTax] = useState<Tax | null>(null);
  const triggers = [pno, pageRows, search, activeId];
  const Privilege = Hooks.Privilege.List(formId);

  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.Tax.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Tax.Name, 
        Name.Tax.Percentage, 
        Name.Tax.Comment
      ]),
    });
     
    await API.Data.List<Tax>(url, setTaxData, setError, setLoading); 
  }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.State} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, taxData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.Tax, width.name],  
                [Title.Percentage, width.percent, Code.Align.CENTER],  
                [Title.Comment, width.comment]
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(taxData) && (
              <Control.Grid.Row>
                {taxData.map((taxData) => { return (
                <Control.Grid.Data<Tax> key={taxData.tax_key} itemKey={taxData.tax_key} data={taxData} setMenuPosition={setMenuPosition} setSelectedData={setselectedTax} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={taxData.tax_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, taxData.tax_key)} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Items values={[
                    [taxData.tax_name, width.name], 
                    [taxData.tax_percentage, width.percent, Code.Align.CENTER], 
                    [taxData.tax_comment, width.comment]
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={taxData.tax_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={taxData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName,selectedTax?.tax_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedTax?.tax_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default TaxList;